import React, { Component } from 'react';
import apiConfig from '../../api/apiConfig'
import './style.css';

class AddSecSubOption extends Component {
  constructor(props){
    super(props)

    this.state={
      pageTitle : 'Add Sec Sub Option',
      pageButton : 'Add Option',
      editOptions : false,
      order_no : "",
      option : "",
      quesId : "",
      subQuesId : "",
      optionID : '',
      option_id : '',
      validationMsg : {},
    }

    this.onChange = this.onChange.bind(this);
    this.saveData = this.saveData.bind(this);
  }

  componentDidMount(){
    if(this.props.quesId){
      this.setState({quesId : this.props.quesId, subQuesId : this.props.subQuesId, secSubQuesId : this.props.secSubQuesId});
    }
  }

  componentWillReceiveProps(nextProps){
    if(nextProps.demoGraphicsSecSubOptionAddSuccess && nextProps.demoGraphicsSecSubOptionSuccessmessage){
      alert(nextProps.demoGraphicsSecSubOptionSuccessmessage);
      this.props.emptyDemographicsSecSubOption();
      window.history.back();
    }else if(nextProps.demoGraphicsSecSubOptionFailmessage){
      alert(nextProps.demoGraphicsSecSubOptionFailmessage);
      this.props.emptyDemographicsSecSubOption();
    }
  }

  onChange(e){
    this.setState({[e.target.name]: e.target.value});
  }

  handleValidation() {
		let valid = true;
    let error = {};

		if (this.state.option === "") {
      error.option = "Can't leave empty";
			valid = false;
    }
    if (this.state.order_no === "") {
      error.order_no = "Can't leave empty";
      valid = false;
		}else if (!this.state.order_no.match(/^\d*$/)){
      error.order_no = "Please only enter numeric characters in order_no";
      valid = false;
    }
    this.setState({ validationMsg: error });
		return valid;
	}

  saveData(){
      let subQuesData = {};
      if (this.handleValidation()) {
        subQuesData.ques_id = this.state.quesId;
        subQuesData.subQuesId = this.state.subQuesId,
        subQuesData.secSubQuesId = this.state.secSubQuesId,
        subQuesData.optionText = this.state.option;
        subQuesData.order_no = this.state.order_no;     
        this.props.addSecSubOptionBySubQuestion(subQuesData);  
      }
  }

  backToPage(){
    window.history.back();
  }


  render() {

      let msg="";
      if(this.props.studyMessage){
        msg = this.props.studyMessage;
      }

      return (
        <div className = "regPage">
            <div className = "createnewstudy">
                <div className = "studyheader"><h1> {this.state.pageTitle}</h1></div>
            <div className = "setbackbutton">
            <br/><button className = "editstudybackbtn"   onClick={this.backToPage.bind(this)}>Back</button><br/>
            <div className = "studypage">
            <label id = "lbl1">Option value</label>
            <input type="text" className = "textFields" placeholder = "Option value" name="option" value={this.state.option} onChange={this.onChange} disabled = {this.state.editOptions} />
            <div style={{ color: "red", textAlign:"center", marginTop: "-15px" }} >{this.state.validationMsg.option}</div><br/>

            {/* <label id = "lbl1">Category ID</label>
            <input type="text" className = "textFields" placeholder = "Category ID" name="catID" value={this.state.catID} onChange={this.onChange} />
            <div style={{ color: "red", textAlign:"center", marginTop: "-15px" }} >{this.state.validationMsg.catID}</div><br/> */}

            <label id = "lbl1">Order No</label>
            <input type="text" className = "textFields" placeholder = "Option Order" name="order_no" value={this.state.order_no} onChange={this.onChange} disabled = {this.state.editOptions} />
            <div style={{ color: "red", textAlign:"center", marginTop: "-15px" }} >{this.state.validationMsg.order_no}</div><br/><br/>
            <div>
            
            <div className = "stdbtn"><button  className="studySavebtn" onClick={this.saveData}  > {this.state.pageButton} </button></div><br/>
            </div>
            <p className = "studyMSG">{msg}</p>
       </div>
       </div>
        </div>
        </div>
    );
  }
}
export default AddSecSubOption;


// WEBPACK FOOTER //
// ./src/components/demographics/addSecSubOption.js